export default __webpack_public_path__ + "static/media/finaOpen.35bfbdca.jpg";